import React from 'react';
import { DollarSign, Target } from 'lucide-react';

export default function RewardsSection({ rewards }) {
  if (!rewards) {
    return (
      <div className="bg-white rounded-2xl p-5 border border-emerald-200 shadow-sm border-l-4 border-l-emerald-500">
        <div className="flex items-center gap-2 mb-4">
          <DollarSign className="w-5 h-5 text-emerald-600" />
          <h2 className="text-lg font-semibold text-slate-900">Reading Rewards</h2>
        </div>
        
        <div className="text-center py-8 text-stone-500">
          <DollarSign className="w-12 h-12 mx-auto mb-4 text-stone-300" />
          <p>Loading your reading rewards...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl p-5 border border-emerald-200 shadow-sm border-l-4 border-l-emerald-500">
      <div className="flex items-center gap-2 mb-4">
        <DollarSign className="w-5 h-5 text-emerald-600" />
        <h2 className="text-lg font-semibold text-slate-900">Reading Rewards</h2>
      </div>

      {/* Current Rewards Total */}
      <div className="bg-emerald-50 rounded-xl p-4 mb-4">
        <div className="text-center mb-3">
          <div className="text-4xl font-bold text-emerald-600 mb-1">
            ${rewards.totalThisMonth?.toFixed(2) || '0.00'}
          </div>
          <div className="text-sm text-emerald-700 font-medium">
            Total Reading Bonus This Month
          </div>
        </div>

        {/* Breakdown Grid */}
        {rewards.breakdown && (
          <div className="grid grid-cols-2 gap-2 text-xs font-medium text-emerald-700">
            {rewards.breakdown.booksCompleted && (
              <div className="bg-white rounded-lg p-2 text-center">
                ${rewards.breakdown.booksCompleted.toFixed(2)} Books Read
              </div>
            )}
            {rewards.breakdown.streakBonus && (
              <div className="bg-white rounded-lg p-2 text-center">
                ${rewards.breakdown.streakBonus.toFixed(2)} Daily Streak
              </div>
            )}
            {rewards.breakdown.speedBonus && (
              <div className="bg-white rounded-lg p-2 text-center">
                ${rewards.breakdown.speedBonus.toFixed(2)} Speed Bonus
              </div>
            )}
            {rewards.breakdown.familySharing && (
              <div className="bg-white rounded-lg p-2 text-center">
                ${rewards.breakdown.familySharing.toFixed(2)} Family Sharing
              </div>
            )}
          </div>
        )}
      </div>

      {/* Next Milestone */}
      {rewards.nextMilestone && (
        <div className="bg-amber-50 rounded-lg p-3 border border-amber-200 flex items-center gap-3">
          <Target className="w-4 h-4 text-amber-600 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm text-amber-700 font-medium">
              {rewards.nextMilestone.description}
            </p>
          </div>
          <div className="w-16 h-2 bg-amber-200 rounded-full overflow-hidden">
            <div 
              className="h-full bg-amber-500 rounded-full transition-all duration-300"
              style={{ width: `${(rewards.nextMilestone.progress || 0) * 100}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Reward Rates Info */}
      <div className="mt-4 p-3 bg-stone-50 rounded-lg">
        <div className="text-xs text-stone-600 space-y-1">
          <div className="flex justify-between">
            <span>Book completion:</span>
            <span className="font-medium">$0.50 each</span>
          </div>
          <div className="flex justify-between">
            <span>7-day streak bonus:</span>
            <span className="font-medium">$1.00</span>
          </div>
          <div className="flex justify-between">
            <span>14-day streak bonus:</span>
            <span className="font-medium">$2.00</span>
          </div>
          <div className="flex justify-between">
            <span>30-day streak bonus:</span>
            <span className="font-medium">$5.00</span>
          </div>
        </div>
      </div>
    </div>
  );
}